/* eslint-disable require-jsdoc */

// GLOWEB-6074 - fullScale (EN locales)
(function() {
	'use strict';

				// datalayer push after click on the "Learn more" button in the "section-avast-one"
				var learnMoreButtons = document.querySelectorAll('.js-learn-more');

				for (var y = 0; y < learnMoreButtons.length; y++) {
					var learnMoreButton = learnMoreButtons[y];

					learnMoreButton.addEventListener('click', function() {
						dataLayer.push({
							event: 'av.genericEvent',
							eventCategory: 'CTA > Other',
							eventAction: 'Learn More',
							eventLabel: 'free-antivirus-download'
						});
					}, {
						once: true
					});
				}

				// datalayer push after click on the expand button in the "accordion-features" section
				var accordionItems = document.querySelectorAll('.illustration-header');

				function pushToDataLayer (element, elementId) {
					element.addEventListener('click', function() {
						dataLayer.push({
							event: 'GAEvent',
							eventCategory: 'adHoc',
							eventAction: 'Privacy features',
							eventLabel: elementId
						});
					}, {
						once: true
					});
				}

				for (var x = 0; x < accordionItems.length; x++) {
					var accordionItem = accordionItems[x],
						expandButton = accordionItem.querySelector('.button-circle'),
						accordionItemId = accordionItem.querySelector('a').id.substring(14);

					pushToDataLayer(expandButton, accordionItemId);

				}
})();
